export default __webpack_public_path__ + "static/media/Akshit Saxena.293f0794.JPG";